var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5273 3.52876C11.7876 3.26841 12.2097 3.26841 12.47 3.52876C12.7304 3.78911 12.7304 4.21112 12.47 4.47147L8.94136 8.00011L12.47 11.5288L12.5156 11.5795C12.7291 11.8414 12.7141 12.2274 12.47 12.4715C12.2259 12.7155 11.8399 12.7306 11.5781 12.517L11.5273 12.4715L7.99865 8.94282L4.47 12.4715C4.20965 12.7318 3.78764 12.7318 3.52729 12.4715C3.26694 12.2111 3.26694 11.7891 3.52729 11.5288L7.05594 8.00011L3.52729 4.47147L3.48172 4.42069C3.26815 4.15884 3.28322 3.77284 3.52729 3.52876C3.77137 3.28468 4.15737 3.26962 4.41922 3.48319L4.47 3.52876L7.99865 7.0574L11.5273 3.52876Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fbc4808c31ed8cefbc4e02003c61b36b.svg";
export { ForwardRef as ReactComponent };